module.exports = require("./ar-YE.d.ts");